import { gql } from "@apollo/client";

export const REGENERATE_VEHICLE_CONDITION_REPORT = gql`
  mutation regenerateVehicleConditionReport($bookingScheduleId: String!, $checkType: String!) {
    regenerateVehicleConditionReport(bookingScheduleId: $bookingScheduleId, checkType: $checkType){
      success
      message
    }
  }
`;